import { render } from "./QimenFormation.vue?vue&type=template&id=1c0ef5be&scoped=true"
import script from "./QimenFormation.vue?vue&type=script&lang=js"
export * from "./QimenFormation.vue?vue&type=script&lang=js"

import "./QimenFormation.vue?vue&type=style&index=0&id=1c0ef5be&scoped=true&lang=css"

import exportComponent from "/Users/jinming/Documents/jhapps/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c0ef5be"]])

export default __exports__